/**
 * Simulator Modal
 * pxb-core Simulator modalをplugin APIから操作する
 *
 * @usage
 * <simulator-modal></simulator-modal>をtemplate内に記述した状態で
 * this.$pxbSim.run(music, project)
 * を実行
 *
 * @todo userOption設定用APIを用意する？
 */

import Component from './Component.vue'
// import ModalsContainer from './ModalsContainer.vue'

const defaultComponentName = 'simulator-modal'

const Plugin = {
  install (Vue, options = {}) {
    /**
     * Makes sure that plugin can be insstalled only once
     */
    if (this.installed) return;

    this.installed = true
    this.event = new Vue() // EventBus
    this.componentName = options.componentName || defaultComponentName

    /**
     * Plugin API
     */
    Vue.prototype.$pxbSim = {
      run (music, project, params) {
        Plugin.event.$emit('run', music, project, params)
      },
      close () {
        Plugin.event.$emit('close')
      }
      // setParam (params) {
      //   Plugin.event.$emit('set', music, project)
      // },
    }

    /**
     * Sets custom component name (if provided)
     */
    Vue.component(this.componentName, Component)

  //   /**
  //    * Registration of <ModalsContainer/> component
  //    */
  //   if (options.dynamic) {
  //     Vue.component('modals-container', ModalsContainer)
  //   }
  }
}

export default Plugin


// WEBPACK FOOTER //
// ./src/plugins/SimulatorModal/index.js